export const WhatsAppButton = () => (
  <a
    href="https://wa.me/393272653401"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Scrivici su WhatsApp"
    data-testid="whatsapp-floating-button"
    className="fixed bottom-5 right-4 z-50 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_0_0_3px_#0b0b0f,0_0_18px_rgba(37,211,102,0.7)] transition-transform duration-150 hover:scale-110 active:scale-95"
    style={{ marginBottom: "env(safe-area-inset-bottom)" }}
  >
    <i className="fa-brands fa-whatsapp text-3xl" aria-hidden="true" />
  </a>
);
